import { Link, useNavigate, useLocation } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);

  // Prevent background scroll when menu open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [menuOpen]);
  
  // Hide navbar on auth pages
  const hideOn = ["/login", "/register"];
  if (hideOn.includes(location.pathname)) return null;

  const handleLogout = () => {
    logout();
    setMenuOpen(false);
    navigate("/login", { replace: true });
  };

  

  return (
    <>
      {/* TOP BAR */}
      <header className="bg-[#121829] sticky top-0 z-50 shadow-md">
        <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
          {/* Logo */}
          <div className="flex flex-col">
            <h2 className="text-[10px] sm:text-xs text-white opacity-80 italic">
              Make your Dream Now With JRJ Family ✨
            </h2>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-6 text-white font-medium">
            <Link to="/" className="hover:text-yellow-300">
              Home
            </Link>
            <Link to="/cal" className="hover:text-yellow-300">
              Calculator
            </Link>
            <button
              onClick={handleLogout}
              className="bg-red-500 hover:bg-red-600 px-4 py-2 rounded text-white"
            >
              Logout
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMenuOpen(true)}
            className="md:hidden text-white"
          >
            ☰
          </button>
        </div>
      </header>

      {/* MOBILE DRAWER */}
      {menuOpen && (
        <div className="fixed inset-0 z-50 bg-[#0f1526] text-white">
          {/* Drawer Header */}
          <div className="flex justify-between items-start px-4 py-4 border-b border-gray-700">
            <div>
              <h2 className="text-lg font-semibold">
                JRJ Financial Consultant PVT LTD
              </h2>
              <p className="text-xs opacity-80 italic">
                Make your Dream Now With JRJ Family ✨
              </p>
            </div>

            <button
              onClick={() => setMenuOpen(false)}
              className="text-2xl leading-none"
            >
              ✕
            </button>
          </div>

          {/* Drawer Links */}
          <div className="px-6 py-8 space-y-6 text-lg">
            <Link
              to="/"
              onClick={() => setMenuOpen(false)}
              className="block border-b border-gray-700 pb-2"
            >
              Home
            </Link>

            <Link
              to="/cal"
              onClick={() => setMenuOpen(false)}
              className="block border-b border-gray-700 pb-2"
            >
              Calculator
            </Link>

            <button
              onClick={handleLogout}
              className="w-full bg-red-500 hover:bg-red-600 py-3 rounded-lg mt-4"
            >
              Logout
            </button>
          </div>
        </div>
      )}
    </>
  );
}
